<footer class="footer-responsive primary-bgpurple">
  <div class="container">
    <div class="row" id="footerAccordion">
      <div class="col-lg-3  ps-lg-5 col-md-6 offset-lg-1 ">
        <div class="accordion-item">
          <h2 class="accordion-header" id="h1">

            <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#c1"
              aria-expanded="true" aria-controls="c1">

              IMPORTANT LINKS

            </button>

          </h2>

          <div id="c1" class="accordion-collapse collapse show" aria-labelledby="h1" data-bs-parent="#footerAccordion">

            <div class="accordion-body">

              <ul>

                <li><a [routerLink]="['/academics']" fragment="exam">Notices</a></li>
                <li><a [routerLink]="['/committees/all-committees']" fragment="training-placement-committee">Training
                    Activities</a></li>
                <li><a [routerLink]="['/academics']" fragment="digital-learning">Digital Learning</a></li>
                <li><a routerLink="/nirf">NIRF</a></li>
                <li><a href="https://drive.google.com/file/d/1vBxEUHT-XMEgWBslfxe0294BY2T6DAEV/view?usp=sharing"
                    target="_blank" rel="noopener noreferrer">NBA</a></li>
                <li><a routerLink="/about/approvals-accreditation">SSR</a></li>

              </ul>
            </div>

          </div>
        </div>
      </div>
      <div class="col-lg-2  col-md-6">
        <div class="accordion-item">

          <h2 class="accordion-header" id="h2">

            <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#c2"
              aria-expanded="false" aria-controls="c2">

              PORTALS

            </button>

          </h2>

          <div id="c2" class="accordion-collapse collapse" aria-labelledby="h2" data-bs-parent="#footerAccordion">

            <div class="accordion-body">

              <ul>
                <li><a href="https://alumni.raisoni.net/" target="_blank" rel="noopener noreferrer">Alumni Portal</a></li>
                <!-- <li><a href="https://raisoni.net/placement">RGI Placement</a></li> -->
                <!-- <li><a href="https://www.rashtriyachhatrasansad.in/" target="_blank" rel="noopener noreferrer">NSP</a></li>
								<li><a href="http://nationalagricultureconclave.com/" target="_blank" rel="noopener noreferrer">NAC</a></li> -->
                <li><a href="https://sgrkf.com/" target="_blank" rel="noopener noreferrer">SGRKF</a></li>
                <li><a href="http://ghrscf.com/" target="_blank" rel="noopener noreferrer">GHRSCF</a></li>

              </ul>

            </div>

          </div>

        </div>
      </div>
      <div class="col-lg-3  col-md-6">
        <div class="accordion-item">

          <h2 class="accordion-header" id="h3">

            <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#c3"
              aria-expanded="false" aria-controls="c3">

              HIGHLIGHTS

            </button>

          </h2>

          <div id="c3" class="accordion-collapse collapse" aria-labelledby="h3" data-bs-parent="#footerAccordion">

            <div class="accordion-body">

              <ul>
                <li> <a href="https://currentopenings.raisoni.net" target="_blank" rel="noopener noreferrer">Current Openings</a></li>
                <li><a routerLink="/events">Events</a></li>
                <li><a [routerLink]="['/students-activity-portal']" fragment="dean-message">Student Welfare</a></li>
                <li><a routerLink="/blogs">Blogs</a></li>

                <li><a [routerLink]="['/research','internship']">Internship</a></li>
                <li><a [routerLink]="['/research','mous-and-industry-sponsored-lab']">MoUs</a></li>
                <li><a [routerLink]="['/committees/all-committees']" fragment="anti-ragging">Anti-Ragging Cell</a></li>


              </ul>

            </div>

          </div>

        </div>
      </div>
      <div class="col-lg-3  col-md-6">
        <div class="accordion-item">

          <h2 class="accordion-header" id="h4">

            <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#c4"
              aria-expanded="false" aria-controls="c4">

              CONTACTS

            </button>

          </h2>

          <div id="c4" class="accordion-collapse collapse" aria-labelledby="h4" data-bs-parent="#footerAccordion">

            <div class="accordion-body">

              <ul class="contact">
                <li><a href="https://maps.app.goo.gl/K7tmYAPWHcttGBdX6" target="_blank" rel="noopener noreferrer"> <i
                      class="material-symbols-outlined">location_on</i>
                    New Gat No. 1200 , Domkhel Road , Wagholi , Pune 412207, Maharashtra
                    State, India</a></li>
                <li><a href="tel:9604787185"> <i class="material-symbols-outlined">call</i> 9604787185</a>,<a
                    href="tel: 9604787186"> <i class="material-symbols-outlined">call</i>
                    9604787186</a>
                </li>
                <li><a href="mailto:ghrcem.pune@raisoni.net"> <i
                      class="material-symbols-outlined">mail</i>ghrcem.pune@raisoni.net</a>
                </li>
              </ul>

            </div>

          </div>

        </div>
      </div>
    </div>
    <div class="row mt-lg-3 justify-content-between flex-row-reverse">

      <div class="col-lg-3  offset-lg-2">
        <div class="social-links">
          <a href="https://www.facebook.com/raisoniworld" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i
              class="fa-brands fa-facebook"></i>
          </a>
          <a href="https://twitter.com/raisoniworld" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i
              class="fa-brands fa-x-twitter "></i>
          </a>
          <a href="https://www.linkedin.com/school/raisoniworld" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i
              class="fa-brands fa-linkedin"></i> </a>
          <a href="http://youtube.com/raisoniworld" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i
              class="fa-brands fa-youtube"></i>
          </a>
          <a href="https://instagram.com/raisoniworld" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i
              class="fa-brands fa-instagram"></i>
          </a>
        </div>
      </div>
      <div class="col-lg-6 col-xxl-7 position-relative">
        <div class="footer-dome my-4 my-lg-0 ">
          <img loading="lazy" decoding="async"
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/logo/footer-dome-white.webp"
            class="img-fluid w-100" alt="Footer dome img">
        </div>
      </div>
    </div>
    <div class="row mt-lg-3 justify-content-between flex-row-reverse g-4 g-lg-0">

      <div class="col-lg-5">
        <div class="text-end privacy">
          <a href="https://raisoni.net/document/privacy_policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> | <a
            href="https://raisoni.net/document/terms_and_conditions.html" target="_blank" rel="noopener noreferrer"> Terms &
            Conditions</a> | <a href="https://raisoni.net/document/refund_and_cancellation.html" target="_blank" rel="noopener noreferrer">Refund
            & Cancellation </a>
        </div>
      </div>
      <div class="col-lg-6 offset-lg-1">
        <p class="mb-0">&copy; {{ currentyear }} All Rights Reserved. Design & Developed by <a
            href="https://globaledu.net.in/" target="_blank" rel="noopener noreferrer">Global
            Education Limited.</a>
        </p>
      </div>
    </div>
  </div>
</footer>
